<div class="ddp-ui-sort" [ngClass]="{ 'ddp-selected': isShowSelect }">
  <a href="javascript:" class="ddp-icon-sort" (click)="isShowSelect = !isShowSelect"></a>

  <div class="ddp-ui-tooltip-info">
    <em class="ddp-icon-view-top"></em>
    {{ 'msg.space.ui.soring.order' | translate }}
  </div>

  <div class="ddp-wrap-popup2">
    <ul class="ddp-list-popup">
      <li
        *ngFor="let item of array"
        [ngClass]="{
          'ddp-selected':
            selectedItem &&
            (isStringArray ? item : item[viewKey]) === (isStringArray ? selectedItem : selectedItem[viewKey])
        }"
      >
        <a href="javascript:" (click)="selected(item)">
          {{ isStringArray ? item : item[viewKey] }}
          <em class="ddp-icon-check"></em>
        </a>
      </li>
    </ul>
  </div>
</div>
